import { useSetAtom } from "jotai";
import { API_UNLOCKED_NAMES } from "../constants/api";
import { UnlockedName } from "../types";
import { useFetch } from "./useFetch";
import { unlockedNamesAtom } from "../store/store";

export const useGetUnlockedNames = () => {
  const { request } = useFetch();
  const setUnlockedNames = useSetAtom(unlockedNamesAtom);

  const getUnlockedNames = async () => {
    try {
      const {
        data: { list },
      } = await request<{ list: UnlockedName[] }>(API_UNLOCKED_NAMES, {
        method: "GET",
      });

      setUnlockedNames(list);
    } catch (error) {}
  };

  return { getUnlockedNames };
};
